import * as R from 'ramda';
import { createSelector } from 'reselect';
import getContentTags from 'selectors/getContentTags';

const getContentTagOptions = createSelector(
  getContentTags,
  R.pipe(
    R.values,
    R.map(R.applySpec({
      label: R.prop('title'),
      value: R.prop('slug'),
    })),
  ),
);

export default getContentTagOptions;
